export const getInitCoords = (store) => store.Map.initCoords;
